import config from 'appconfig';
import environment from 'appconfig/environment';
import { DEVELOPMENT } from 'model/EnvironmentConfig';
import uuid from 'uuid';

const getStatsigEnv = () => {
  const originEnv = environment.toLowerCase();

  // We need this override as we are not able to specify the local env on statsig
  if (originEnv === 'local') return DEVELOPMENT;

  return originEnv;
};

declare global {
  interface Window {
    FEATURE_GATES?: object;
  }
}

export const statsigConfig = {
  sdkKey: config.statsigClientSDK,
  waitForInitialization: true,
  options: {
    environment: { tier: getStatsigEnv() },
  },
  user: { userID: uuid() },
};
